module.exports = __webpack_public_path__ + "img/shape-metal_af-mobile-gold@2x.527739a8.png";